import {format} from 'date-fns';

export function formattedDayOfMonth(dayOfMonth) {
  return format(new Date(new Date().getFullYear(), 0, dayOfMonth), 'do');
}
